<div class="day-tile" [class.day-tile--active]="active()" [ngClass]="{'day-tile__can-click': day().hourly.length > 0}">
  <div class="day-tile__icon">
    <dsy-icon [name]="iconConfig(day().summaryCode).name" [library]="iconConfig(day().summaryCode).library" [size]="'1.38rem'"></dsy-icon>
  </div>
  <div class="day-tile__name">{{ label() }}</div>
  <div class="day-tile__number">{{ max | number : '1.0-0' }}°{{ unit() }}</div>
  <div class="day-tile__number">{{ min | number : '1.0-0' }}°{{ unit() }}</div>
</div>
